export const states = {
    useHash: true,
    api: null,
    apiBaseParamName: 'tx_epim_productfinder',
    config: {},
    localization: {},
    availableFilters: {},
    results: [],
    total: 0,
    filterStates: {},
    hash: 'start',
    background: '',
    freeze: true
};
